<template>
  <article class="popup popup-right-control">
    <header class="header popup-top">
      <h2 class="title">
        {{$t('popups.thingsRightsControl.title')}}
      </h2>
      <div class="popup-top_btns">
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <form class="content right-form"
          @submit.prevent="setRights">
      <div class="select-cont select-cont_multiple" v-if="isUserType || isOwnerType">
        <p class="label">{{$t('popups.thingsRightsControl.shareClient')}}</p>
        <v-select multiple
                  :searchable="true"
                  v-model="users"
                  :clearable="false"
                  label="email"
                  :options="usersArr"></v-select>
      </div>
      <div  class="select-cont select-cont_multiple" v-if="isRoleType">
        <p class="label">{{$t('btns.things.thingOwnerRole')}}</p>
        <v-select multiple
                  :searchable="true"
                  v-model="roles"
                  :clearable="false"
                  label="name"
                  :options="rolesArr"></v-select>
      </div>
      <h3 class="subtitle" v-if="!isOwnerType">
        {{$t('popups.thingsRightsControl.subtitle')}}
      </h3>
      <div class="permission-wrap" v-if="!isOwnerType">
        <p class="label">
          {{$t('labels.allRights')}}
        </p>
        <permission-toggler @level="setLevel($event)"
                            class="permission-toggler"></permission-toggler>
      </div>
      <div class=" btn-cont">
        <button type="button"
                :disabled="loading"
                @click="closeAll"
                class="btn btn-transparent_red">{{$t('btns.cancel')}}</button>
        <button type="submit"
                class="btn btn-transparent_blue"
                :class="{'loading': loading}"
                :disabled="disabledBtn">
          {{$t('btns.accept')}}
        </button>
      </div>
    </form>
  </article>
</template>

<script>
  import closeBtn from '../../closeBtn'
  import {addThing} from "../../../../mixins/things/addThings";
  import {mapState, mapActions} from 'vuex'
  import {popups} from "../../../../mixins/popups";
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";

  export default {
    name: 'thingsRightsControl',
    mixins: [addThing, popups, tokenAndRoute],
    components: {
      closeBtn
    },
    data() {
      return {
        loading: false,
        changedDefault: true,
      }
    },
    computed: {
      ...mapState({
        checkedRole: state => state.things.defaultRight,
        thing: state => state.things.device,
        rightsType: state => state.things.rightsType,
        thingType: state => state.things.deviceType
      }),
      disabledUser() {
        return this.users.length === 0
      },
      disabledRole() {
        return this.roles.length === 0;
      },
      isUserType() {
        return this.rightsType === 'user'
      },
      isRoleType() {
        return this.rightsType === 'role'
      },
      isOwnerType() {
        return this.rightsType === 'owner'
      },
      disabledBtn() {
        if (this.isUserType || this.isOwnerType) {
          return this.loading || this.disabledUser
        } else {
          return this.loading || this.disabledRole
        }
      }
    },
    methods: {
      ...mapActions({
        setPermissions: 'things/setPermissions',
        getProjects: 'projects/getProjects',

      }),
      setLevel(level) {
        this.level = level;
        this.changedDefault = true
      },
      async setRights() {
        this.loading = true;

        let data = {
          device_id: this.thing.id,
          value: this.level
        };

        if (this.isOwnerType) {
          data.value = 4
        };

        if (this.isUserType || this.isOwnerType) {
          let email = this.users.map(item => {
            if (item.email) {
              return item.email
            } else {
              return item
            }
          }).join(',');
          data.emails = email;
        } else {
          let ids = this.roles.map(item => {
            return item.id
          }).join(',');
          data.roles_ids = ids
        };

        if (this.changedDefault) {
          await this.changeDefaultRight(data);
        };

        this.loading = false;
        this.closeAll()
      },
      async changeDefaultRight(data) {
        let dataPer = {
          data,
          token: this.token,
        };

        await this.setPermissions(dataPer)
          await this.getProjects();
      },
    },
    mounted() {
      if (this.checkedRole) {
        if (this.isUserType) {
          this.checkedRole.forEach(item => {
            this.users.push(item.role.owner.contacts.email)
          });
        } else {
          this.checkedRole.forEach(item => {
            this.roles.push({name: item.role.name, id: item.role.id})
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .popup-right-control {
    padding: 0;
    width: 420px;
  }

  .header {
    padding: 30px;
   // margin-bottom: 60px!important;
  }

  .content {
    padding: 30px;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .big {
    font-family: $msb;
    font-size: 21px;
    letter-spacing: .15px;
    margin-bottom: 20px;
  }

  .small {
    font-family: $mr;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .btn-cont {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;

    .btn {
      width: calc(50% - 10px);
    }
  }

  .select-cont {
    margin-bottom: 20px;
  }

  .subtitle {
    font-family: $msb;
    font-size: 16px;
    text-align: left;
    margin-bottom: 30px;
    margin-top: 10px;
  }
</style>
